export function hasNonEnglishLang(resources) {
  return resources?.some((el) => el.language && el.language !== 'english')
}